import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import elementMixin from './mixins/elementMixin'

// Import full Element Plus CSS (individual CSS imports miss transitive dependencies)
import 'element-plus/theme-chalk/index.css'

// Import Element Plus components used in templates
import {
  ElButton,
  ElNotification,
  ElAutocomplete,
  ElDatePicker,
  ElTimePicker
} from 'element-plus'

// Configure dayjs
import dayjs from 'dayjs'
import locale from 'dayjs/plugin/localeData'
dayjs.extend(locale)
dayjs.locale('en')

// Import global styles (order matters)
import '@/assets/styles/variables.css'
import '@/assets/styles/tailwind.css'
import '@/assets/styles/main.css'

// Initialize the app
const app = createApp(App)
const pinia = createPinia()

// Register Element Plus components
app.component(ElButton.name as string, ElButton)
app.component(ElAutocomplete.name as string, ElAutocomplete)
app.component(ElDatePicker.name as string, ElDatePicker)
app.component(ElTimePicker.name as string, ElTimePicker)
app.config.globalProperties.$notify = ElNotification
app.config.globalProperties.$dayjs = dayjs

app.use(pinia)
app.use(router)
app.use(elementMixin)
app.mount('#app')
